import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Two DIFFERENT bounces used to share this one message, so a screenshot of it
  // could not say which: "the organization did not load" and "you are not in
  // it" are separate failures with separate causes.
  noOrganizationAccess: {
    id: 'pages.organizations.noOrganizationAccess',
    defaultMessage: 'You are not part of this organization.',
  },
  organizationUnavailable: {
    id: 'pages.organizations.organizationUnavailable',
    defaultMessage:
      'This organization could not be opened. It may not exist or may be unavailable right now.',
  },
  // The bounce lands on a page that has nothing to do with the organization
  // that failed, so "this organization" is unanswerable from where the reader
  // ends up. Named whenever the name is actually known — never guessed.
  noOrganizationAccessNamed: {
    id: 'pages.organizations.noOrganizationAccessNamed',
    defaultMessage: 'You are not part of {organizationName}.',
  },
  organizationUnavailableNamed: {
    id: 'pages.organizations.organizationUnavailableNamed',
    defaultMessage:
      '{organizationName} could not be opened. It may be unavailable right now.',
  },
  noOrganizationsFound: {
    id: 'pages.organizations.noOrganizationsFound',
    defaultMessage: 'No organizations found',
  },
  organizationSelectionFailed: {
    id: 'pages.organizations.organizationSelectionFailed',
    defaultMessage: 'The organization could not be selected.',
  },
  retryOrganizationSelection: {
    id: 'pages.organizations.retryOrganizationSelection',
    defaultMessage: 'Try again',
  },
});

export default messages;
